import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subsidiary-dashboard-contract',
  templateUrl: './subsidiary-dashboard-contract.component.html',
  styleUrls: ['./subsidiary-dashboard-contract.component.css']
})
export class SubsidiaryDashboardContractComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
